import { REGEX_CONSTANT } from "../../../constant/regexConstant";

export const validCustomer = (namespace, data, translate) => {
  let error = {};

  switch (namespace) {
    case "recipient_name":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate('Recipient\'s Name'),
        });
      } else if (data.length > 50) {
        error[namespace] = translate("Max 50 character", {
          field: translate('Recipient\'s Name'),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "recipient_phone":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate('Recipient\'s Phone'),
        });
      } else if (!REGEX_CONSTANT.PHONE_NUMBER.test(data.replace('+62-', ''))) {
        error[namespace] = translate("Invalid Format", {
          field: translate('Recipient\'s Phone'),
        });
      } else if (data.replace('+62-', '').length > 12 || data.replace('+62-', '').length < 10) {
        error[namespace] = translate("min 10 character, max 12 character", {
          field: translate('Recipient\'s Phone'),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "first_name":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:FIRST_NAME"),
        });
      } else if (data.length > 50) {
        error[namespace] = translate("Max 50 character", {
          field: translate("CUSTOMER:FIRST_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "last_name":
      if (data.length > 50) {
        error[namespace] = translate("Max 50 character", {
          field: translate("CUSTOMER:LAST_NAME"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "email":
      // if (!data) {
      //   error[namespace] = translate("COMMON:REQUIRE", {
      //     field: translate("CUSTOMER:EMAIL"),
      //   });
      // }else 
      if (data.length > 100) {
        error[namespace] = translate("COMMON:MAX_LENGTH", {
          field: translate("CUSTOMER:EMAIL"),
        });
      } else if (data.length > 0 && !REGEX_CONSTANT.EMAIL.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "phone":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:PHONE"),
        });
      } else if (data.length > 12 || data.length < 10) {
        error[namespace] = translate("min 10 character, max 12 character", {
          field: translate("CUSTOMER:EMAIL"),
        });
      } else if (!REGEX_CONSTANT.PHONE_NUMBER.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "fax":
      // if (!data) {
      //   error[namespace] = translate("COMMON:REQUIRE", {
      //     field: translate("CUSTOMER:FAX"),
      //   });
      // }else 
      if (!REGEX_CONSTANT.FAX.test(data) && data.length > 0) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "country_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:CUSTOMER_COUNTRY"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    // case "island_id":
    // if (!data) {
    //   error[namespace] = translate("COMMON:REQUIRE", {
    //     field: translate("CUSTOMER:CUSTOMER_ISLAND"),
    //   });
    // } else {
    //   error[namespace] = null;
    // }
    // break;
    case "province_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:CUSTOMER_PROVINCE"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "district_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:CUSTOMER_DISTRICT"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "sub_district_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:CUSTOMER_SUB_DISTRICT"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "urban_village_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:CUSTOMER_URBAN_VILLAGE"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "address":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:CUSTOMER_ADDRESS"),
        });
      } else if (data.length > 256) {
        error[namespace] = translate("COMMON:MAX_LENGTH", {
          field: translate("CUSTOMER:CUSTOMER_ADDRESS"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "neighbourhood":
      if (data.length > 3) {
        error[namespace] = translate("COMMON:MAX_LENGTH", {
          field: translate("CUSTOMER:NEIGHBOURHOOD"),
        });
      } else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "hamlet":
      if (data.length > 3) {
        error[namespace] = translate("COMMON:MAX_LENGTH", {
          field: translate("CUSTOMER:HAMLET"),
        });
      } else if (!REGEX_CONSTANT.INTEGER.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "postal_code":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:POSTAL_CODE"),
        });
      } else if (data.length > 30) {
        error[namespace] = translate("COMMON:MAX_LENGTH", {
          field: translate("CUSTOMER:POSTAL_CODE"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "longitude":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:LONGITUDE"),
        });
      } else if (data.length > 100) {
        error[namespace] = translate("COMMON:MAX_LENGTH", {
          field: translate("CUSTOMER:LONGITUDE"),
        });
      } else if (!REGEX_CONSTANT.LNG_LAT.test(data)) {
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    case "latitude":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("CUSTOMER:LATITUDE"),
        });
      } else if (data.length > 100) {
        error[namespace] = translate("COMMON:MAX_LENG\TH", {
          field: translate("CUSTOMER:LATITUDE"),
        });
      } else if (!REGEX_CONSTANT.JUST_LAT.test(data)) {
        error[namespace] = translate("Invalid format", {
          field: translate("CUSTOMER:LATITUDE"),
        });
      } else {
        error[namespace] = null;
      }
      break;
    default:
      break;
  }
  return error;
};
